import React from 'react';
import './Marker.css';

const TrackerMarker = (props) => {
    const { tracker } = props;
    const [showInfo, setShowInfo] = React.useState(false);
    return (
      <div className="marker"
        style={{ backgroundColor: 'white', height: "25px",  cursor: 'pointer', width: '90px', borderRadius: "10%", textAlign: "center"}}
        onMouseOver ={() => setShowInfo(true)} 
        onMouseOut ={() => setShowInfo(false)}
      >
        <div style={{color: 'black', paddingLeft: 4, paddingTop: 4, fontSize: 14, textTransform: "uppercase"}}>
            {tracker["name"] || 'N'}
        </div>
        {
            showInfo ? 

            <div style={{height: "100px", width: "200px", fontSize: 16, marginTop: -130, backgroundColor: "white", justifyContent: "center", alignContent: "center", alignItems: "center", padding: 10, borderColor: "green", borderWidth: 10, borderRadius: "10px"}}>
                <div style={{marginTop: 4, color: "black"}}>
                    Last updated {"\n"}
                    {
                      new Date(tracker.time * 1000)
                      .toLocaleString(
                        "en-US", 
                        {
                          hour: 'numeric',
                          minute: '2-digit',
                          second: '2-digit',
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour12: true,
                        }
                      )
                    }
                </div>
            </div>
            :
            <></>
        }
        
        </div>
    );
  };

  export default TrackerMarker;